import { useMutation } from "@tanstack/react-query";

import { addProfileToCalendar } from "../../../../../modules/admin/booking/services/api";

export const useAddBookingConfigProfileCalendars = () =>
  useMutation(async (value: any) => addProfileToCalendar(value));
